// extracted by mini-css-extract-plugin
module.exports = {"spec":"Spec_spec__fPwu9"};